import merge from 'lodash.merge'
import { SuiExtension } from '@credenza3/core-web-sui-ext'

import { config } from '@packages/utils/config'
import { retrieveCredenzaAccess } from '@src/Passport.service'
import { clientPublicStore, isLoggedInStore, pageStore, suiPackageStore } from '@packages/stores'
import { PassportEvents, dispatch } from '@lib/events/events'

import type { Passport } from '@src/Passport'
import type { TPassortSuiExtension, TPassportConstructor, TSuiNetwork } from '@packages/utils/types'
import { get } from 'svelte/store'
import { initCredenzaSDK, sdk } from '@lib/sdk/sdk'
import { configStore } from '@src/stores/config'
import { NetworkTypes, SuiNetworks } from '@packages/utils/enums'
import { suiPackages } from '@src/utils/config'
import { analytics } from '@packages/utils/lib/mixpanel/mixpanel'
import { initSuiSigner } from '@src/libs/sui'
import { getClientSettings, openClientWelcomMessage } from '@lib/clients'

export async function configurePassport(this: Passport, opts: TPassportConstructor<TPassortSuiExtension>) {
  this.networkType = opts.suiNetwork === SuiNetworks.MAINNET ? NetworkTypes.MAINNET : NetworkTypes.TESTNET
  this.config = {
    ...merge(config[this.networkType], opts.config || {}),
    suiNetwork: opts.suiNetwork,
    clientId: opts.clientId,
    networkType: this.networkType,
  }
  this.suiNetwork = this.config.suiNetwork as TSuiNetwork
  this.suiPackage = this.config.storedValuePackageId || suiPackages[this.config.suiNetwork]
  suiPackageStore.set(this.suiPackage)
  configStore.set(this.config)
}

export async function init(this: Passport) {
 
  try {
    const { suiNetwork, auth, clientId, credenza } = this.config
    const clientSettingsRes = await getClientSettings(credenza.accountsApiUrl, clientId);
    clientPublicStore.set(clientSettingsRes); 
    const suiExtensions: unknown[] = []

    if (auth?.zk === true) {
      const { ZkLoginExtension } = await import('@credenza3/core-web-sui-zklogin-ext')
      suiExtensions.push(new ZkLoginExtension())
    }

    const extensions = [new SuiExtension({ suiNetwork: suiNetwork, extensions: suiExtensions })]
    const initPromise = initCredenzaSDK(clientId, extensions, this.networkType)
    sdk.on(PassportEvents.LOGIN, async () => {
      await onSdkLogin(initPromise)
      openClientWelcomMessage(this.openUI)
    })
    await initPromise

    if (!sdk.getAccessToken()) return
    await initSuiSigner(sdk.getAccessToken() as string)
    await retrieveCredenzaAccess()
  } catch (_) {
    /** */
  }
  dispatch(PassportEvents.INIT)
  if (get(isLoggedInStore) && !get(pageStore)) this.close()
}

const onSdkLogin = async (initSdkPromise: Promise<void>) => {
  await initSdkPromise
  const user = await sdk.account.info()
  await initSuiSigner(sdk.getAccessToken() as string)
  const { suiNetwork, clientId } = get(configStore)
  void analytics.track('cp_login', {
    $email: user.email,
    $phone: user.phone,
    suiNetwork: suiNetwork,
    clientId,
    address: await sdk.sui.getAddress(),
    location: window.location.href,
  })
  dispatch(PassportEvents.LOGIN, { user })
}
